import "core-js/modules/es6.reflect.construct.js";
import _classCallCheck from "/builds/trova-cantieri/frontend/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js";
import _createClass from "/builds/trova-cantieri/frontend/node_modules/@babel/runtime-corejs2/helpers/createClass.js";
import _inherits from "/builds/trova-cantieri/frontend/node_modules/@babel/runtime-corejs2/helpers/inherits.js";
import _possibleConstructorReturn from "/builds/trova-cantieri/frontend/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js";
import _getPrototypeOf from "/builds/trova-cantieri/frontend/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js";
import _defineProperty from "/builds/trova-cantieri/frontend/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
// User Model
import VuexORM from '@vuex-orm/core';
import Image from "./Image";
import TypologyCategory from "./TypologyCategory";
import { i18n } from 'src/boot/i18n';
var Typology = /*#__PURE__*/function (_VuexORM$Model) {
  _inherits(Typology, _VuexORM$Model);
  var _super = _createSuper(Typology);
  function Typology() {
    _classCallCheck(this, Typology);
    return _super.apply(this, arguments);
  }
  _createClass(Typology, [{
    key: "price",
    get: function get() {
      if (this.for_sale) {
        return this.sell_price;
      }
      return this.rent_price;
    }
  }, {
    key: "$delete",
    value: function $delete(companyId) {
      return Typology.api().delete("/api/companies/".concat(companyId, "/constructions/").concat(this.construction_id, "/typologies/").concat(this.id));
    }
  }, {
    key: "$duplicate",
    value: function $duplicate(companyId) {
      return Typology.api().post("/api/companies/".concat(companyId, "/constructions/").concat(this.construction_id, "/typologies/").concat(this.id, "/duplicate"));
    }
  }, {
    key: "$markSold",
    value: function $markSold(companyId) {
      return Typology.api().put("/api/companies/".concat(companyId, "/constructions/").concat(this.construction_id, "/typologies/").concat(this.id, "/mark-sold"));
    }
  }, {
    key: "$markInNegotiation",
    value: function $markInNegotiation(companyId, inNegotiation) {
      return Typology.api().post("/api/companies/".concat(companyId, "/constructions/").concat(this.construction_id, "/typologies/").concat(this.id), {
        code: this.code,
        description: this.description,
        area: this.area,
        in_negotiation: inNegotiation ? 1 : 0,
        order_number: this.order_number
      });
    }
  }, {
    key: "$markForSale",
    value: function $markForSale(companyId) {
      return Typology.api().put("/api/companies/".concat(companyId, "/constructions/").concat(this.construction_id, "/typologies/").concat(this.id, "/mark-for-sale"));
    }
  }], [{
    key: "entity",
    get:
    // This is the name used as module name of the Vuex Store.
    function get() {
      return 'typologies';
    }
  }, {
    key: "fields",
    value:
    // List of all fields (schema) of the user model. `this.attr` is used
    // for the generic field type. The argument is the default value.
    function fields() {
      return {
        id: this.attr(null),
        code: this.attr(null),
        order_number: this.attr(null),
        description: this.attr(null),
        video_url: this.attr(null),
        area: this.attr(null),
        rent_price: this.attr(null),
        sell_price: this.attr(null),
        in_negotiation: this.boolean(null),
        for_rent: this.boolean(null),
        for_sale: this.boolean(null),
        commercial: this.boolean(null),
        residential: this.boolean(null),
        terrain: this.boolean(null),
        sold: this.boolean(null),
        reserved_negotiation: this.boolean(null),
        rooms: this.attr(null),
        bathrooms: this.attr(null),
        energy_class_text: this.attr(''),
        minimum_ipe: this.attr(''),
        construction_id: this.attr(null),
        typology_category_id: this.number(null),
        typology_category: this.belongsTo(TypologyCategory, 'typology_category_id'),
        images: this.morphMany(Image, 'imageable_id', 'imageable_type')
      };
    }
  }]);
  return Typology;
}(VuexORM.Model);
_defineProperty(Typology, "VISIBILITY_OPTIONS", [{
  label: i18n.t('app.typologies.visibility_options.visible'),
  value: 'visible'
}, {
  label: i18n.t('app.typologies.visibility_options.reserved'),
  value: 'reserved'
}]);
_defineProperty(Typology, "DESTINATION_OPTIONS", [{
  label: i18n.t('app.typologies.destination_options.residential'),
  value: 'residential'
}, {
  label: i18n.t('app.typologies.destination_options.commercial'),
  value: 'commercial'
}, {
  label: i18n.t('app.typologies.destination_options.terrain'),
  value: 'terrain'
}]);
_defineProperty(Typology, "CONTRACT_OPTIONS", [{
  label: i18n.t('app.typologies.contract_options.for_sale'),
  value: 'for_sale'
}, {
  label: i18n.t('app.typologies.contract_options.for_rent'),
  value: 'for_rent'
}]);
export { Typology as default };